import { Button, Center, Loader, Modal } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';

import { useSyncWosPublications } from '@/module/Dashboard/model/DashboardQuery';

import { useFreezeDate } from '@/feature/utils/hooks/useFreezeDate';

export function WosSyncButton() {
  const { mutate, isPending } = useSyncWosPublications();
  const { t } = useTranslation();
  const { isAfterFreezeDate } = useFreezeDate();

  const handleSyncWos = () =>
    mutate(undefined, {
      onError: () =>
        notifications.show({
          color: 'red',
          title: t('notification.error.title'),
          message: t('notification.error.content'),
        }),
      onSuccess: () =>
        notifications.show({
          color: 'green',
          title: t('wos.sync.notif.title'),
          message: t('wos.sync.notif.content'),
        }),
    });

  return (
    <>
      {isPending && (
        <Modal
          opened
          onClose={() => {
            /* no-op */
          }}
          withCloseButton={false}
          title={t('wos.sync.inProgress')}
        >
          <Center>
            <Loader color="blue" />
          </Center>
        </Modal>
      )}
      <Button
        size="xs"
        loading={isPending}
        onClick={handleSyncWos}
        disabled={isAfterFreezeDate}
      >
        Sync WoS
      </Button>
    </>
  );
}
